// определение светлый/темный шрифт для RGB бэкграунда

export function rgbIsLight(r: number, g: number, b: number) {
  const rNum = r / 255;
  const gNum = g / 255;
  const bNum = b / 255;

  const cmin = Math.min(rNum, gNum, bNum),
    cmax = Math.max(rNum, gNum, bNum),
    delta = cmax - cmin;
  let h = 0,
    l = 0;

  if (delta === 0) h = 0;
  else if (cmax === rNum) h = ((gNum - bNum) / delta) % 6;
  else if (cmax === gNum) h = (bNum - rNum) / delta + 2;
  else h = (rNum - gNum) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;

  l = +(l * 100).toFixed(1);

  if (l > 50) return true;
  else return false;
}
